export default {
   state: {
      form: '',
      sent: false
   },

   setForm (form) {
      this.state.form = form
   }
}
